/* eslint-disable no-mixed-operators */
import React from 'react'

import { ReactComponent as GridLinesIcon } from '../../assets/icons/header/grid-lines.svg'
import { ReactComponent as ElectricIcon } from '../../assets/icons/header/electric.svg'
import { ReactComponent as GasIcon } from '../../assets/icons/header/gas.svg'
import { ReactComponent as NationalGridLogoIcon } from '../../assets/icons/header/national-grid-logo.svg'

const CONTENT_WEB_URL = process.env.REACT_APP_CONTENT_WEB_URL
const CSS_TRX_WEB_URL = process.env.REACT_APP_CSS_TRX_WEB_URL

const Header = () => (
  <header className="main-header">
    <nav>
      <ul>
        <li>
          <a href={`${CONTENT_WEB_URL}/Upstate-NY-Business/Default.aspx`}>
            <GridLinesIcon />
            <span>Go to nationalgridus.com</span>
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a href={`${CONTENT_WEB_URL}/Upstate-NY-Business/Natural-Gas-Safety/Report-a-Gas-Emergency`}>
            <GasIcon />
            <span>Gas Emergencies</span>
          </a>
        </li>
        <li>
          <a href={`${CSS_TRX_WEB_URL}/outages`}>
            <ElectricIcon />
            <span>Power Outages</span>
          </a>
        </li>
        <li className="visible-desktop">
          <a href={`${CONTENT_WEB_URL}/Upstate-NY-Business/Contact-Us/`}>
            <span>Contact Us</span>
          </a>
        </li>
      </ul>
    </nav>

    <h2 className="hero-unit">
      <NationalGridLogoIcon />
      <span>Upstate NY Electric</span>
    </h2>
  </header>
)

export default Header
